export default {
  methods: {
    getBooleanBadge(status) {
      return status ? 'success' : 'danger'
    }
  },
}